var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-search-box", {
        on: { enter: _vm.getList },
        scopedSlots: _vm._u([
          {
            key: "search",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                  },
                  [
                    _c("c-select", {
                      attrs: {
                        comboItems: _vm.gubunItems,
                        type: "none",
                        itemText: "codeName",
                        itemValue: "code",
                        name: "gubun",
                        label: "조회구분",
                      },
                      on: { datachange: _vm.datachange },
                      model: {
                        value: _vm.searchParam.gubun,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "gubun", $$v)
                        },
                        expression: "searchParam.gubun",
                      },
                    }),
                  ],
                  1
                ),
                _vm.searchParam.gubun === "chemNm"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            name: "chemNm",
                            label: "화학물질영문명 (2자 이상 입력)",
                          },
                          model: {
                            value: _vm.searchParam.chemNm,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchParam, "chemNm", $$v)
                            },
                            expression: "searchParam.chemNm",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.searchParam.gubun === "casNo"
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            name: "casNo",
                            label: "CAS No. (2자 이상 입력)",
                          },
                          model: {
                            value: _vm.searchParam.casNo,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchParam, "casNo", $$v)
                            },
                            expression: "searchParam.casNo",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                  },
                  [
                    _c("c-datepicker", {
                      attrs: {
                        range: true,
                        label: "고시일자",
                        name: "notiDtPeriod",
                      },
                      model: {
                        value: _vm.searchParam.notiDtPeriod,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "notiDtPeriod", $$v)
                        },
                        expression: "searchParam.notiDtPeriod",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                  },
                  [
                    _c("c-select", {
                      attrs: {
                        comboItems: _vm.flagItems,
                        label: "변경유형",
                        itemText: "codeName",
                        itemValue: "code",
                        name: "flag",
                        type: "search",
                      },
                      model: {
                        value: _vm.searchParam.flag,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "flag", $$v)
                        },
                        expression: "searchParam.flag",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2",
                  },
                  [
                    _c("c-select", {
                      attrs: {
                        comboItems: _vm.sendMailFlagItems,
                        label: "메일발송 여부",
                        itemText: "codeName",
                        itemValue: "code",
                        name: "sendMailFlag",
                        type: "search",
                      },
                      model: {
                        value: _vm.searchParam.sendMailFlag,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "sendMailFlag", $$v)
                        },
                        expression: "searchParam.sendMailFlag",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                  },
                  [
                    _c("c-multi-select", {
                      attrs: {
                        type: "search",
                        codeGroupCd: "REGULATION_BILL_API_CD",
                        itemText: "codeName",
                        itemValue: "code",
                        label: "관련 법규",
                        name: "regulationBillCds",
                      },
                      on: { datachange: _vm.billCdChange },
                      model: {
                        value: _vm.searchParam.regulationBillCds,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "regulationBillCds", $$v)
                        },
                        expression: "searchParam.regulationBillCds",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                  },
                  [
                    _c("c-multi-select", {
                      attrs: {
                        type: "search",
                        comboItems: _vm.regulatedItems,
                        itemText: "regulatedItemName",
                        itemValue: "regulatedItemCd",
                        label: "규제 법규",
                        name: "regulatedItemCds",
                      },
                      model: {
                        value: _vm.searchParam.regulatedItemCds,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchParam, "regulatedItemCds", $$v)
                        },
                        expression: "searchParam.regulatedItemCds",
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("c-table", {
        ref: "table",
        attrs: {
          title: _vm.tableTitle,
          columns: _vm.grid.columns,
          data: _vm.grid.data,
          columnSetting: false,
          usePaging: false,
          editable: _vm.editable,
          selection: "multiple",
          rowKey: "mdmMaterialRegulatoryInfoHistoryDetailId",
        },
        on: { linkClick: _vm.linkClick },
        scopedSlots: _vm._u([
          {
            key: "table-button",
            fn: function () {
              return [
                _c(
                  "q-btn-group",
                  { attrs: { outline: "" } },
                  [
                    _vm.editable
                      ? _c("c-btn", {
                          attrs: { label: "메일 발송", icon: "mail" },
                          on: { btnClicked: _vm.sendMail },
                        })
                      : _vm._e(),
                    _c("c-btn", {
                      attrs: { label: "검색", icon: "search" },
                      on: { btnClicked: _vm.getList },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "customArea",
            fn: function ({ props, col }) {
              return [
                col.name === "sendMailFlagName"
                  ? [
                      _c(
                        "span",
                        {
                          style: {
                            color:
                              props.row.sendMailFlag === "Y"
                                ? "#21BA45"
                                : "#C10015",
                            fontWeight: 600,
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                props.row.sendMailFlagName ||
                                  (props.row.sendMailFlag === "Y"
                                    ? "발송"
                                    : "미발송")
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }